import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBlogPostBuilderOutlineSection,
  BackendMutationSwitchBlogPostBuilderOutlineSectionsArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SwitchBlogPostBuilderOutlineSections($sectionId1: ID!, $sectionId2: ID!) {
    switchBlogPostBuilderOutlineSections(sectionId1: $sectionId1, sectionId2: $sectionId2) {
      id
    }
  }
`;

type Variables = BackendMutationSwitchBlogPostBuilderOutlineSectionsArgs;
type Result = Pick<BackendBlogPostBuilderOutlineSection, 'id'>[];

export const switchBlogPostBuilderOutlineSections = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
